import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rpt-per',
  templateUrl: './rpt-per.component.html',
  styleUrls: ['./rpt-per.component.scss']
})
export class RptPerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  competencias:any;

}
